<template>
  <div class="hello">
    <a-menu mode="inline" theme="dark" :defaultOpenKeys="openKeys" :defaultSelectedKeys="defaultSelectedKeys" :selectedKeys="defaultSelectedKeys">
      <template v-for="item in menus">
        <a-menu-item v-if="hasPerm(item) && !item.children" :key="item.key" @click="clear()">
          <a-icon :component="item.icon" v-if="item.icon" />
          <span>{{item.title}}</span>
          <router-link :to="item.to" v-if="item.to" />
        </a-menu-item>
        <sub-menu v-if="hasPerm(item) && item.children" :menu-info="item" :key="item.key"  @click="clear()"/>
      </template>
    </a-menu>
  </div>
</template>

<script>
import subMenu from './SubMenu';
import SvgIcAll from '../assets/svg/ic-all-o.svg';

export default {
  components: {
    subMenu,
    SvgIcAll,
  },

  props: {
    menusData: Object,
  },

  data() {
    return {};
  },

  created() {},

  computed: {
    menus() {
      return this.menusData.menus;
    },

    openKeys() {
      return this.menusData.openKeys || [];
    },

    defaultSelectedKeys() {
      return this.menusData.defaultSelectedKeys || [];
    },
  },

  methods: {
    hasPerm(item) {
      const { checkFn, checkAction, checkRole } = item;

      return this.$lkAdmin.checkPerm(
        { checkFn, checkAction, checkRole },
        { ctx: item, src: 'children' },
      );
    },

    clear() {
      window.localStorage.setItem(
        "queryParams",
        null
      );
    }
  },
};
</script>

<style scoped lang="less">
.ant-menu-inline-collapsed {
  width: 48px;
}
</style>
